import { dasherizeParts, Stat } from "@timing71/common";
import { parseTime as parseNormalTime } from '../utils.js';
import { FlagState } from '../../../common/src/racing.js';

const BIKE = ["Bike", "text"];

const COLUMN_SPEC = [
  Stat.NUM,
  Stat.STATE,
  Stat.DRIVER,
  Stat.TEAM,
  BIKE,
  Stat.LAPS,
  Stat.GAP,
  Stat.INT,
  Stat.LAST_LAP,
  Stat.BEST_LAP
];

export const getManifest = (data) => {
  return {
    name: data.head.category,
    description: dasherizeParts(data.head.event_tv_name, data.head.session_name),
    colSpec: COLUMN_SPEC
  };
}

export const getState = (data) => {
  return {
    session: mapSession(data.head),
    cars: postProcessRiders(mapBikes(Object.values(data.rider)))
  }
}

const mapBikes = (riders) => {
  return riders.map(
    rider => {
      const lastLapTime = parseTime(rider.last_lap_time);
      const bestLapTime = parseTime(rider.lap_time);

      const lltFlag = lastLapTime === bestLapTime ? 'pb' : '';

      const gap = parseTime(rider.gap_first);
      const interval = parseTime(rider.gap_prev);

      let status = mapBikeState(rider.trac_status);
      if (rider.status_name === 'NS') {
        status = 'N/S';
      }
      else if (rider.on_pit) {
        status = 'PIT';
      }

      return ([
        rider.rider_number,
        status,
        `${rider.rider_surname}, ${rider.rider_name}`,
        rider.team_name,
        rider.bike_name,
        rider.last_lap,
        gap !== 0 ? gap : '',
        interval !== 0 ? interval : '',
        lastLapTime > 0 ? [lastLapTime, lltFlag] : ['', ''],
        bestLapTime > 0 ? [bestLapTime, 'old'] : ['', '']
      ]);
    }
  );
}

const parseTime = (weirdTime) => parseNormalTime(weirdTime.replaceAll("'", ":"));

const BIKE_STATE_MAP = {
  'NS': 'N/S',
  'B': 'PIT',
  'T': 'RUN'
}

const mapBikeState = (state) => BIKE_STATE_MAP[state] || state;

const postProcessRiders = (riders) => {
  let fastLapIndex = -1;
  let fastLapTime = null;

  riders.forEach(
    (rider, idx) => {
      const blt = rider[rider.length - 1][0];
      if (blt > 0 && (!fastLapTime || fastLapTime > blt)) {
        fastLapIndex = idx;
        fastLapTime = blt;
      }
    }
  );

  if (fastLapIndex >= 0) {
    const fastRider = riders[fastLapIndex];
    fastRider[fastRider.length - 1][1] = 'sb';

    if (fastRider[fastRider.length - 1][0] === fastRider[fastRider.length - 2][0]) {
      fastRider[fastRider.length - 2][1] = 'sb-new';
    }
  }

  return riders;
}

const SESSION_STATE_MAP = {
  'F': FlagState.CHEQUERED,
  'I': FlagState.RED,
  'S': FlagState.GREEN,
  'N': FlagState.NONE
}

const mapSession = (head) => {
  const remain = parseInt(head.remaining, 10);

  const isRace = !!head.num_laps;

  const session = {
    flagState: SESSION_STATE_MAP[head.session_status_id] || FlagState.NONE,
  }

  if (isRace) {
    session['lapsRemain'] = remain;
  }
  else {
    session['remain'] = remain;
  }

  return session;
}
